import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateCoachBiographyInput {
	readonly id: string;
	readonly description: string;
}

export interface UpdateCoachBiographyParams {
	input: UpdateCoachBiographyInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateCoachBiographyApiMutation extends ApiMutation<
	UserOutput,
	UpdateCoachBiographyParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateCoachBiography($input: UpdateCoachBiographyInput!) {
			updateCoachBiography(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'updateCoachBiography';
}
